'use client';

import React, { useEffect, useState } from 'react';

import { useInView } from 'react-intersection-observer';

import { createGenericContext } from '../generateContext';

type ContextInterface = {
  isVisible?: boolean;
  footerRef?: (node?: Element | null | undefined) => void;
};

const [useFooterContext, FooterContextProvider] =
  createGenericContext<ContextInterface>();

const IsVisibleFooterProvider = (
  props: React.PropsWithChildren<unknown>
): React.JSX.Element => {
  const [isVisible, setIsVisible] = useState(false);

  const { ref: footerRef, inView } = useInView({ threshold: 0.15 });

  useEffect(() => {
    setIsVisible(inView);
  }, [inView]);

  return (
    <FooterContextProvider
      value={{
        isVisible,
        footerRef,
      }}
    >
      {props.children}
    </FooterContextProvider>
  );
};
export { useFooterContext, IsVisibleFooterProvider };
